
    import { defineComponent, PropType } from "vue"
    import ListAdd from "./ListAdd.vue"
    import ListAddLine from "./ListAddLine.vue"
    import Loader from "./Loader.vue"

    export default defineComponent({
        props: {
            loading: {
                type: Boolean,
                default: () => false
            },
            items: Array,
            addInPos: Boolean,
            hideTopAdd: Boolean
        },
        components: {
            Loader,
            ListAddLine,
            ListAdd,

        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            addFromSlot(val: string, index: number) {
                this.$emit("add", { name: val, pos: index });
                (this.$refs["addLine" + index] as any)[0].showInput = false
            },
        },
    })

    